export default __webpack_public_path__ + "static/resurs-bank-a814320a1b37d81cb4caf4a0f8b1c876.png";